import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function CheckoutCancel() {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen pt-20 lg:pt-24 flex items-center justify-center" data-testid="checkout-cancel-page">
      <div className="max-w-lg mx-auto px-4 text-center">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', damping: 15 }}
          className="w-24 h-24 rounded-full bg-destructive/10 mx-auto flex items-center justify-center mb-6"
        >
          <XCircle className="w-12 h-12 text-destructive" />
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <h1 className="text-3xl font-bold font-heading text-text_primary mb-4" data-testid="cancel-title">
            {t('orderCancelled')}
          </h1>
          <p className="text-text_secondary mb-8">
            {t('orderCancelledMessage')}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/checkout"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white font-semibold rounded-full hover:bg-primary_hover transition-all"
              data-testid="retry-checkout-button"
            >
              Réessayer le paiement
              <ArrowRight className="w-4 h-4" />
            </Link>
            <Link
              to="/products"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-secondary/50 text-text_primary font-semibold rounded-full hover:bg-secondary transition-all"
            >
              {t('continueShopping')}
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
